// extracted by mini-css-extract-plugin
module.exports = {"white":"white_white__0uQ0G"};